import TabType3 from "./tabType3";

export default TabType3;
